import React, { useCallback, useEffect, useState } from 'react';
import * as yup from 'yup';
import { useContentContext } from '../../../Context/ContactContext';

interface ITextField {
    label: string;
    name: string;
    autoComplete?: string;
    required?: boolean;
    sentAttempt: boolean;
    type?: 'text' | 'textarea';
    email?: boolean;
}

const TextField: React.FC<ITextField> = (props) => {
    const { name, label, required, autoComplete, sentAttempt, email, type } = props;

    const [context, setContext] = useContentContext();

    const [isValid, setIsValid] = useState(true);

    const validate = useCallback(async (): Promise<void> => {
        if (sentAttempt) {
            let schema = yup.string();
            if (required) schema = schema.required();
            if (email) schema = schema.email();
            setIsValid(await schema.isValid(context[name]));
        }

        return undefined;
    }, [required, context, sentAttempt, email, name]);

    const setValueHandler = useCallback(
        (newValue = '') => {
            // setValue(newValue);

            const newContext = { ...context };
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            newContext[name] = newValue;
            setContext(newContext);
        },
        [context, name, setContext]
    );

    useEffect(() => {
        // eslint-disable-next-line no-void
        void validate();
    }, [context, sentAttempt, validate]);

    return (
        <>
            <label
                htmlFor={name}
                className={`transition-all block text-sm font-medium ${
                    !isValid ? 'text-red-700' : 'text-gray-700'
                }`}
            >
                {label}
                {required ? '*' : ''}
                <div className="mt-1">
                    {type === 'text' && (
                        <input
                            type="text"
                            name={name}
                            value={context[name] as string}
                            onChange={(e) => setValueHandler(e.target.value)}
                            autoComplete={autoComplete}
                            className={`${!isValid ? 'inputInvalid' : ''} input transition-all`}
                        />
                    )}

                    {type === 'textarea' && (
                        <textarea
                            name={name}
                            value={context[name] as string}
                            onChange={(e) => setValueHandler(e.target.value)}
                            autoComplete={autoComplete}
                            rows={4}
                            className={`${
                                !isValid ? 'inputInvalid' : ''
                            } transition-all py-3 px-4 block w-full shadow-sm focus:ring-secondary focus:border-secondary border border-gray-300 rounded-md`}
                        />
                    )}
                </div>
            </label>
        </>
    );
};

TextField.defaultProps = {
    required: false,
    autoComplete: '',
    email: false,
    type: 'text',
};

export default TextField;
